import React, { Fragment, useState } from 'react';
import ModalVideo from 'react-modal-video'
import ModernHeader from '../../components/header/ModernHeader';
import Scrollbar from '../../components/scrollbar/scrollbar'
import ModernFooter from '../../components/footer/ModernFooter';
import CtaSection from '../../components/CtaSection/CtaSection';
import { Box, Typography, Container, Grid, Card, CardContent, Chip, alpha, Avatar } from "@mui/material"
import { Factory, Truck, Settings, Handshake, Target, DollarSign, Zap, Clock, Lightbulb, Award, BookOpen, HeadphonesIcon, Shield, CheckCircle } from "lucide-react"



const ServiceSinglePage = (props) => {


    const partnerships = [
        {
            title: "Leading Manufacturers",
            icon: <Factory size={48} />,
            description: "Collaborating with top-tier manufacturing partners to ensure quality and innovation",
            color: "#5f7fbc",
            features: ["Quality Assurance", "Innovation Pipeline", "Global Reach"],
        },
        {
            title: "Nationwide Suppliers & Distributors",
            icon: <Truck size={48} />,
            description: "Extensive network ensuring seamless supply chain and distribution coverage",
            color: "#388e3c",
            features: ["National Coverage", "Logistics Excellence", "Inventory Management"],
        },
        {
            title: "Industry Solution Providers",
            icon: <Settings size={48} />,
            description: "Strategic alliances with technology and solution providers for comprehensive offerings",
            color: "#f57c00",
            features: ["Technical Expertise", "Integrated Solutions", "Industry Knowledge"],
        },
    ]
    const strengths = [
        {
            id: 1,
            title: "Standing government contracting experience",
            description: "Decades of proven expertise in government contract management and compliance.",
            icon: Award,
        },
        {
            id: 2,
            title: "Deep industry knowledge",
            description: "Comprehensive understanding of government processes and requirements.",
            icon: BookOpen,
        },
        {
            id: 3,
            title: "Rapid, responsive support",
            description: "Quick turnaround times with dedicated support for all your needs.",
            icon: HeadphonesIcon,
        },
        {
            id: 4,
            title: "Government-compliant solutions",
            description: "All solutions meet strict government standards and regulations.",
            icon: Shield,
        },
    ]


    const valuePoints = [
        {
            icon: Target,
            title: "Streamlined acquisition strategies",
            description: "Optimized processes for efficient resource acquisition",
            color: "#5f7fbc",
        },
        {
            icon: DollarSign,
            title: "Cost savings & operational efficiency",
            description: "Reduced expenses through smart operational improvements",
            color: "#388e3c",
        },
        {
            icon: Zap,
            title: "Scalable, future-ready solutions",
            description: "Adaptable systems designed for long-term growth",
            color: "#f57c00",
        },
        {
            icon: Clock,
            title: "On-time project execution",
            description: "Reliable delivery within agreed timelines",
            color: "#7b1fa2",
        },
        {
            icon: Lightbulb,
            title: "Continuous innovation & compliance",
            description: "Ongoing advancement while maintaining standards",
            color: "#d32f2f",
        },
    ]
    const [isOpen, setOpen] = useState(false)

    return (
        <Fragment>
            <div className="sco_agency">
                <ModernHeader />
                <main className="page_content service-single-page">
                    <section className="page-title  pt-200 pb-45 pos-rel text-white" style={{
                        backgroundImage: "linear-gradient(135deg, #5f7fbc 0%, #5f7fbc 100%)",
                    }}>
                        <div className="container">
                            <div className="page-title-wrap sd-title-wrap">
                                <div className="row mt-none-30 align-items-end">
                                    <div className="col-lg-9 mt-2">
                                        <div className="page-title-box">
                                            <span className="sub-title text-white "> <Zap className="w-4 h-4 text-white" /> Jaak Tech Services</span>
                                            <h4 className="title text-white">Leading value-added reseller and
                                                trusted technology partner.  <br /></h4>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 mt-30">
                                        <div className="sd-right-img pos-rel">
                                            <img src='https://media.istockphoto.com/id/1249627376/vector/online-conclusion-of-the-transaction-the-opening-of-a-new-startup-business-handshake-via.jpg?s=612x612&w=0&k=20&c=0tJipnXnLbcdaI0DXkhaXlbJbua57i0Cu70aeHksA8o=' alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <br></br>
                    <div className="sd-ser-content_wrap pb-50">
                        <div className="container">
                            <div className="sd-ser-content">
                                <h2 className="sd-title">Boost your authority with link building</h2>
                                <p className="sd-content">
                                    Jaak Tech is a leading value-added reseller and trusted technology partner for government agencies and enterprise clients. We deliver a comprehensive range of advanced ICT and office solutions, including:
                                    Networking Equipment: Switches, routers, firewalls
                                    Computing Devices: Laptops, desktops, servers
                                    Storage Systems: Scalable, high-capacity solutions up to 10TB
                                    Peripherals: Printers, scanners, and essential accessories
                                    Who We Are
                                    As a Disadvantaged Minority-Owned Small Business, Jaak Tech is dedicated to driving operational efficiency while minimizing costs. Our mission is to empower clients with the tools and expertise needed to thrive in today's digital landscape.
                                    Our Capabilities
                                    Diverse Product Portfolio
                                    400+ networking devices, 900+ computing systems, enterprise-grade storage
                                    Customized Solutions
                                    Performance-boosting strategies tailored to your organization's needs.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="sd-process_warp">
                        <div className="container">
                            <div className="sd-heading">
                                <h2 className="sd-title">Service process</h2>
                                <p className="sd-content">End-to-End Services Cybersecurity: Secure your operations with best-in-class tools Software Solutions: Built to address your unique business challenges Procurement & Fulfillment: Reliable sourcing and delivery Why Partner With Jaak Tech Competitive Pricing Free Shipping on orders over $3,000 Flexible Return Policy – 7-day satisfaction guarantee Let's Build the Future Together From federal agencies to private enterprises, Jaak Tech is your go-to partner for dependable, future-ready ICT solutions. Contact us to learn how we can support your mission and technology goals.</p>
                            </div>

                            <div className="sd-process_inner ul_li">
                                {strengths.map((item, index) => {
                                    const IconComponent = item.icon;
                                    return (
                                        <div className="sd-process-item" key={item.id}>
                                            <div className="xb-item--icon">
                                                <span style={{ fontSize: '2rem', color: '#5f7fbc' }}>
                                                    <IconComponent size={40} />
                                                </span>
                                            </div>
                                            <h3 className="xb-item--title mb-0">{item.title}</h3>
                                            <p className="xb-item--contact">{item.description}</p>
                                            <span className="xb-item--number">
                                                {String(index + 1).padStart(2, '0')}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>

                        </div>
                    </div>




                    <Box
                        sx={{
                            minHeight: "100vh",
                            background: `linear-gradient(135deg, ${alpha("#5f7fbc", 0.05)} 0%, ${alpha("#388e3c", 0.05)} 100%)`,
                            py: 8,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Container maxWidth="lg">
                            {/* Header Section */}
                            <Box textAlign="center" mb={6}>
                                <Box display="flex" alignItems="center" justifyContent="center" mb={3}>
                                    <Handshake sx={{ fontSize: 56, color: "#5f7fbc", mr: 2 }} />
                                    <Typography
                                        variant="h2"
                                        component="h1"
                                        sx={{
                                            fontWeight: 700,
                                            background: "linear-gradient(45deg, #5f7fbc, #388e3c)",
                                            backgroundClip: "text",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent",
                                            fontSize: { xs: "2.5rem", md: "3.5rem" },
                                        }}
                                    >
                                        Strategic Partnerships
                                    </Typography>
                                </Box>
                                <Typography
                                    variant="h5"
                                    color="text.secondary"
                                    sx={{
                                        maxWidth: 600,
                                        mx: "auto",
                                        fontWeight: 300,
                                        lineHeight: 1.6,
                                    }}
                                >
                                    Building strong alliances to deliver exceptional value and comprehensive solutions
                                </Typography>
                            </Box>

                            {/* Partnership Cards */}
                            <Grid container spacing={4}>
                                {partnerships.map((partnership, index) => (
                                    <Grid item xs={12} md={4} key={index}>
                                        <Card
                                            sx={{
                                                height: "100%",
                                                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                                                cursor: "pointer",
                                                border: `3px solid transparent`,
                                                "&:hover": {
                                                    transform: "translateY(-8px)",
                                                    boxShadow: `0 20px 40px ${alpha(partnership.color, 0.2)}`,
                                                    border: `2px solid ${alpha(partnership.color, 0.3)}`,
                                                },
                                            }}
                                        >
                                            <CardContent sx={{ p: 4, textAlign: "center" }}>
                                                {/* Icon */}
                                                <Box
                                                    sx={{
                                                        width: 80,
                                                        height: 80,
                                                        borderRadius: "50%",
                                                        background: `linear-gradient(135deg, ${partnership.color}, ${alpha(partnership.color, 0.7)})`,
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        mx: "auto",
                                                        mb: 3,
                                                        color: "white",
                                                    }}
                                                >
                                                    {partnership.icon}
                                                </Box>

                                                {/* Title */}
                                                <Typography
                                                    variant="h5"
                                                    component="h3"
                                                    gutterBottom
                                                    sx={{
                                                        fontWeight: 600,
                                                        color: partnership.color,
                                                        mb: 2,
                                                    }}
                                                >
                                                    {partnership.title}
                                                </Typography>

                                                {/* Description */}
                                                <Typography
                                                    variant="body1"
                                                    color="text.secondary"
                                                    sx={{
                                                        mb: 3,
                                                        lineHeight: 1.6,
                                                        minHeight: 48,
                                                    }}
                                                >
                                                    {partnership.description}
                                                </Typography>

                                                {/* Features */}
                                                <Box display="flex" flexDirection="column" gap={1}>
                                                    {partnership.features.map((feature, featureIndex) => (
                                                        <Chip
                                                            key={featureIndex}
                                                            label={feature}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: alpha(partnership.color, 0.1),
                                                                color: partnership.color,
                                                                fontWeight: 500,
                                                                "&:hover": {
                                                                    backgroundColor: alpha(partnership.color, 0.2),
                                                                },
                                                            }}
                                                        />
                                                    ))}
                                                </Box>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>

                            {/* Bottom Section */}
                            <Box
                                textAlign="center"
                                mt={8}
                                p={4}
                                sx={{
                                    background: alpha("#fff", 0.8),
                                    borderRadius: 3,
                                    backdropFilter: "blur(10px)",
                                    border: `1px solid ${alpha("#000", 0.1)}`,
                                }}
                            >
                                <Typography
                                    variant="h6"
                                    sx={{
                                        fontWeight: 600,
                                        color: "#5f7fbc",
                                        mb: 2,
                                    }}
                                >
                                    Together, We Deliver Excellence
                                </Typography>
                                <Typography variant="body1" color="text.secondary" sx={{ maxWidth: 800, mx: "auto", lineHeight: 1.7 }}>
                                    Our strategic partnerships enable us to provide comprehensive solutions, maintain the highest quality
                                    standards, and deliver exceptional value to our clients across all markets and industries.
                                </Typography>
                            </Box>
                        </Container>
                    </Box>


                    <Box
                        sx={{
                            minHeight: "100vh",
                            py: 8,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <Container maxWidth="lg">
                            {/* Header */}
                            <Box sx={{ textAlign: "center", mb: 8 }}>
                                <Typography
                                    variant="h2"
                                    component="h1"
                                    sx={{
                                        fontWeight: 700,
                                        color: "#1a202c",
                                        mb: 2,
                                        fontSize: { xs: "2.5rem", md: "3.5rem" },
                                    }}
                                >
                                    Value We Deliver
                                </Typography>
                                <Box
                                    sx={{
                                        width: 96,
                                        height: 4,
                                        bgcolor: "#5f7fbc",
                                        mx: "auto",
                                        borderRadius: 2,
                                    }}
                                />
                            </Box>

                            {/* Value Points Grid */}
                            <Grid container spacing={4}>
                                {valuePoints.map((point, index) => {
                                    const IconComponent = point.icon
                                    return (
                                        <Grid item xs={12} sm={6} lg={4} key={index}>
                                            <Card
                                                sx={{
                                                    height: "100%",
                                                    transition: "all 0.3s ease-in-out",
                                                    "&:hover": {
                                                        transform: "translateY(-8px)",
                                                        boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                                                    },
                                                    borderRadius: 3,
                                                    border: "1px solid rgba(0,0,0,0.08)",
                                                }}
                                            >
                                                <CardContent
                                                    sx={{
                                                        p: 4,
                                                        textAlign: "center",
                                                        height: "100%",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <Avatar
                                                        sx={{
                                                            width: 64,
                                                            height: 64,
                                                            bgcolor: "#5f7fbc15",
                                                            mb: 3,
                                                            transition: "all 0.3s ease-in-out",
                                                        }}
                                                    >
                                                        <IconComponent
                                                            className="icon"
                                                            size={32}
                                                            style={{
                                                                color: point.color,
                                                                transition: "color 0.3s ease-in-out",
                                                            }}
                                                        />
                                                    </Avatar>

                                                    <Typography
                                                        variant="h6"
                                                        component="h3"
                                                        sx={{
                                                            fontWeight: 600,
                                                            color: "#1a202c",
                                                            mb: 2,
                                                            lineHeight: 1.3,
                                                        }}
                                                    >
                                                        {point.title}
                                                    </Typography>

                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            color: "#64748b",
                                                            lineHeight: 1.6,
                                                            fontSize: "0.875rem",
                                                        }}
                                                    >
                                                        {point.description}
                                                    </Typography>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    )
                                })}
                            </Grid>

                            {/* Bottom accent */}
                            <Box sx={{ mt: 8, textAlign: "center" }}>
                                <Box
                                    sx={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: 1,
                                        color: "#64748b",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            width: 8,
                                            height: 8,
                                            bgcolor: "#5f7fbc",
                                            borderRadius: "50%",
                                        }}
                                    />
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                        Delivering Excellence
                                    </Typography>
                                    <Box
                                        sx={{
                                            width: 8,
                                            height: 8,
                                            bgcolor: "#5f7fbc",
                                            borderRadius: "50%",
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Container>
                    </Box>



                    <div className="sd-service_wrap pt-115 pb-130">
                        <div className="container">
                            <div className="sd-ser-outcome">
                                <div className="sd-heading">
                                    <h2 className="sd-title">Services outcome</h2>
                                    <p className="sd-content">Here are six key points related to "Boost Your Authority with Link Building" in the context of digital transformation and risk management <br /> solutions for Fortune 500 companies, with a bit more detail:</p>
                                </div>
                                <div className="sd-list-item ul_li">
                                    <ul className="sd-ser-list list-unstyled">
                                        <li><CheckCircle size={20} color="#5f7fbc" style={{ marginRight: '8px' }} />Enhance Credibility and Trust.</li>
                                        <li><CheckCircle size={20} color="#5f7fbc" style={{ marginRight: '8px' }} />Improve Search Engine Rankings.</li>
                                        <li><CheckCircle size={20} color="#5f7fbc" style={{ marginRight: '8px' }} />Foster Strategic Partnerships.</li>
                                    </ul>
                                    <ul className="sd-ser-list list-unstyled">
                                        <li><CheckCircle size={20} color="#5f7fbc" style={{ marginRight: '8px' }} />Showcase Thought Leadership.</li>
                                        <li><CheckCircle size={20} color="#5f7fbc" style={{ marginRight: '8px' }} />Drive Targeted Traffic.</li>
                                        <li><CheckCircle size={20} color="#5f7fbc" style={{ marginRight: '8px' }} />Support Long-Term Growth.</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <CtaSection />
            </div>
            <ModernFooter />
            <Scrollbar />
            <ModalVideo channel='youtube' autoplay isOpen={isOpen} videoId="7e90gBu4pas" onClose={() => setOpen(false)} />
        </Fragment>
    )
};
export default ServiceSinglePage;
